module.exports = {
  returnName: {
    1: 'Processar',
    2: 'ComErros' || 'ErroCarga',
    3: 'Reprocessar',
    4: 'ComErros' || 'ErroImportacao',
    5: 'Liberar' || 'LiberarRetorno',
    6: 'PreVenda',
    7: 'Alteracao',
    8: 'PreVenda' || 'PreVendaAlteracao',
    9: 'ImportacaoParcial',
    10: 'Liberar' || 'LiberarRetornoParcial',
    11: 'ComErros' || 'ErroLiberacao',
  },

  returnNameFormatted: {
    1: 'Processar',
    2: 'Erro na carga',
    3: 'Reprocessar',
    4: 'Erro na importação',
    5: 'Liberar retorno',
    6: 'Pré-venda',
    7: 'Alteração',
    8: 'Pré-venda com alteração',
    9: 'Importação parcial',
    10: 'Liberar retorno parcial',
    11: 'Erro de liberação',
  },
  returnId: {
    Processar: 1,
    ErroNaCarga: 2,
    Reprocessar: 3,
    ErroNaImportacao: 4,
    LiberarRetorno: 5,
    PreVenda: 6,
    Alteracao: 7,
    PreVendaComAlteracao: 8,
    ImportacaoParcial: 9,
    LiberarRetornoParcial: 10,
    ErroDeLiberacao: 11,
  },
  returnNameForName: {
    Processar: 'Processar',
    ErroNaCarga: 'ErroNaCarga',
    Reprocessar: 'Reprocessar',
    ErroNaImportacao: 'ErroNaImportacao',
    LiberarRetorno: 'LiberarRetorno',
    PreVenda: 'PreVenda',
    Alteracao: 'Alteracao',
    PreVendaComAlteracao: 'PreVendaComAlteracao',
    ImportacaoParcial: 'ImportacaoParcial',
    LiberarRetornoParcial: 'LiberarRetornoParcial',
    ErroDeLiberacao: 'ErroDeLiberacao',
  },
  returnNameForTab: {
    Todas: 0,
    Processar: 1,
    Reprocessar: 3,
    Liberar: [5, 10],
    Alteracao: 7,
    PreVenda: [6, 8],
    Importacao: 9,
    ComErros: [2, 4, 11],
  },
  returnTabForName: {
    Todas: 'Todas',
    Processar: 'Processar',
    Reprocessar: 'Reprocessar',
    Liberar: 'Liberar',
    Alteracao: 'Alteracao',
    PreVenda: 'PreVenda',
    Importacao: 'Importacao',
    ComErros: 'ComErros',
  },
};
